import pluralize from 'pluralize';

/**
 * Returns singular or plural form of a word based on the count
 * @param {string} text - The word to pluralize
 * @param {number} count - The count to determine pluralization
 * @return {string} - Singular form if count is 1, plural form otherwise
 */
export const pluralizeWord = (text: string, count: number): string => {
  if (count === 1) {
    return text;
  }
  return pluralize(text);
};

export default pluralizeWord;
